export default "__VITE_ASSET__24686b74__"